//@sample-repo
import Vue from 'vue'

const url = Vue.prototype.$config.api_url +  Vue.prototype.$config.report.final_report_votes

const finalReportVotes = {
  list(code:string|number, params = {}) {
    const Url = url.replace("{0}", code) 
    return Vue.prototype.$httpService.get(Url, params)
  },
  find(code:string|number, id:string|number) {
    let Url = `${url.replace("{0}", code)}/${id}`
    return Vue.prototype.$httpService
    .get(Url)
  },
  create(code:string|number, payload:any, queryString:string='') {
    let Url = url.replace("{0}", code)
    if(queryString){
      Url = `${Url}?${queryString}`
    }
    return Vue.prototype.$httpService
    .post(Url, payload)
  },
  edit(code:string|number, id:string|number, payload:any) {
    let Url = `${url.replace("{0}", code)}/${id}`
    return Vue.prototype.$httpService
    .put(Url, payload)
  },
  partial_edit(code:string|number, id:string|number,payload:any){
    let Url = `${url.replace("{0}", code)}/${id}`
    return Vue.prototype.$httpService
    .patch(Url,payload)
  },
  delete(code:string|number, id:string|number) {
    let Url = `${url.replace("{0}", code)}/${id}`
    return Vue.prototype.$httpService.delete(Url)
  },
}

export default finalReportVotes;

